import { gql } from '@apollo/client';
export const StatFeatureTaskManagement = gql `
    fragment StatFeatureTaskManagement on TaskManagementFeatureSettingsFlags {
        isEnabled
        canToggle
    }
`;
